import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import Button from "../Button";
import logo from "../../assets/images/logo.svg";
import mobilelogo from "../../assets/images/mobilelogo.svg";
import HeaderLinks from "./HeaderLinks";
import User from "./HeaderUser";
import CartPopUp from "../CartPopUp/CartPopUp";

import { useSelector, useDispatch } from "react-redux";
import { fetchUserProfile } from "../../store/slices/profileSlice";
import { fetchCart, syncLocalCartToServer } from "../../store/slices/cartSlice";
import { setAuthRedirectPath } from "../../store/userSlice";
import { getLocalCart } from "../../utils/localCart";
import { useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const {cart, localItems} = useSelector(state => state.cart)

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { isAuthenticated } = useSelector((state) => state.user);
  const { profile } = useSelector((state) => state.profile);

  const openCart = () => {
    console.log('Cart button clicked!');
    console.log('Current showCart state:', showCart);
    console.log('Current cart state:', cart);
    setShowCart((prev) => !prev);
  };
  const closeCart = () => {
    setShowCart(false);
  };

  const handkeGoToMainPage = () => {
    navigate("/");
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleSignIn = () => {
    // Сохраняем текущий путь для редиректа после успешного логина
    dispatch(setAuthRedirectPath(location.pathname + location.search));
    navigate("/authorization");
  };

  // Закрываем корзину при смене маршрута (чтобы PaddleCheckout не висел в фоне)
  useEffect(() => {
    setShowCart(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchUserProfile());
      // Синхронизируем гостевую корзину с сервером (если есть) после OAuth логина
      const localCart = getLocalCart();
      if (localCart.length > 0) {
        dispatch(syncLocalCartToServer());
      } else {
        dispatch(fetchCart());
      }
    }
  }, [dispatch, isAuthenticated]);

  return (
    <header className={styles.main}>
      <div className={styles.container}>
        <div className={styles.logocont} onClick={handkeGoToMainPage}>
          <img src={logo} alt="logo" />
        </div>
        <div className={styles.logo} onClick={handkeGoToMainPage}>
          <img src={mobilelogo} alt="m-logo" />
        </div>
        <HeaderLinks
          isMenuOpen={isMenuOpen}
          handleCloseMenu={handleCloseMenu}
        />
        <div className={styles.btncont}>
          <div style={{position: 'relative'}}>
            <Button
              labelPosition="none"
              variant={windowWidth > 1000 ? "transparent" : "grey"}
              color="white"
              iconType="cart"
              style={{ color: 'grey' }}
              onClick={openCart}
            />
            {((cart?.items?.length || 0) + (localItems?.length || 0)) > 0 && 
            <p className={styles.cartCount}>{(cart?.items?.length || 0) + (localItems?.length || 0)}</p>
            }     
          </div>
          <div>
            {isAuthenticated ? (
              <User user={profile} />
            ) : (
              <div className={styles.signInbtn}>
                <Button
                  label="Sign In"
                  variant="blue"
                  iconType="person"
                  labelPosition={windowWidth > 768 ? "left" : "none"}
                  onClick={handleSignIn}
                />
              </div>
            )}
          </div>
          <div className={styles.mobilebtn}>
            <Button
              labelPosition="none"
              variant="grey"
              iconType="headerMenu"
              onClick={() => setIsMenuOpen((prev) => !prev)}
            />
          </div>
        </div>
      </div>
      {showCart && (
        <>
          {console.log('Rendering CartPopUp, showCart is true')}
          <CartPopUp closeCart={closeCart} />
        </>
      )}
    </header>
  );
};

export default Header;
